import { Component, Input } from '@angular/core';

@Component({
  selector: 'terra-unit-payment-overview-key-value-pair',
  templateUrl: './unit-payment-overview-key-value-pair.component.html',
  styleUrls: ['./unit-payment-overview-key-value-pair.component.scss']
})
export class UnitPaymentReviewKeyValuePairComponent {
  @Input() key: string;
  @Input() value: string | number;
  @Input() unit: string;
  @Input() iconName: string;
  @Input() link: string;

  get hasKeyAndValue(): boolean {
    const hasKey = this.key !== null && this.key !== undefined;
    const hasValue = this.value !== null && this.value !== undefined;

    return hasKey && hasValue;
  }
}
